module.exports = __webpack_public_path__ + "static/media/gallery-3.27a45644.jpg";